module.exports = __webpack_public_path__ + "static/media/gray_15.b963cbca.jpg";